import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {TYPE_PARTNER} from "../../../../helpers/typePartner"

class ColTypePartner extends Component {
    render() {
        const {type} = this.props
        const typeDetail = TYPE_PARTNER.find(item => item.value === type)

        return (
            <td className='ColTypePartner'>
                {typeDetail !== undefined && typeDetail.name}
            </td>
        )
    }
}

ColTypePartner.propTypes = {
    type: PropTypes.string
}

export default ColTypePartner